import onElementExistRunForEach from 'helpers/jquery/onElementExistRunForEach';

onElementExistRunForEach('.agri_jobs_planned_table', (index, element) => {
  void import('./internal/agri_jobs_planned_table')
    .then(({ default: Component }) => Component(element));
});
